var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"openapp-wrap"},[_c('button',{staticClass:"openapp-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('open-app')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }